// component
import PersonPinIcon from '@mui/icons-material/PersonPin';
import PeopleIcon from '@mui/icons-material/People';
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard',
    icon: icon('ic_analytics'),
  },
  {
    title: 'user',
    path: '/user',
    icon: <PeopleIcon />,
  },
  // {
  //   title: 'Profile',
  //   path: '/profile',
  //   icon: <PersonPinIcon />,
  // },
  // {
  //   title: 'product',
  //   path: '/dashboard/products',
  //   icon: icon('ic_cart'),
  // },
  // {
  //   title: 'blog',
  //   path: '/dashboard/blog',
  //   icon: icon('ic_blog'),
  // },
];

export default navConfig;
